import React from "react";
import { StyledButton } from "../../styled";
import { useStudioDetails } from "../../context";
import useRolePermission from "entities/auth/hooks/useRolePermission";
import Box from "@mui/material/Box";

const ActionButton = () => {
  const {
    onSaveStudioDetails,
    onSaveStudioTranslations,
    isSubmittingStudio,
  } = useStudioDetails();
  const { allowed: hasWriteAccess } = useRolePermission("studios:write");
  const { allowed: hasWriteTranslationsAccess } = useRolePermission("studios:translations:write");

  if (!hasWriteAccess && !hasWriteTranslationsAccess) {
    return null;
  }

  if (!hasWriteAccess && hasWriteTranslationsAccess) {
    return (
      <Box>
        <StyledButton
          title="Save"
          size="small"
          onClick={onSaveStudioTranslations}
          loading={isSubmittingStudio}
        />
      </Box>
    );
  }

  return (
    <Box>
      <StyledButton
        title="Save"
        size="small"
        onClick={onSaveStudioDetails}
        loading={isSubmittingStudio}
      />
    </Box>
  );
};

export default ActionButton;